import React, { useEffect, useState } from "react";
import {
  AppBar, Toolbar, Typography, IconButton, Stack, styled
} from "@mui/material";
import {
Menu as MenuIcon,
} from "@mui/icons-material";
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import ProfileMenu from "./ProfileMenu";
// import { ThemeToggleButton } from "../../themes/utils/toggleButton";
import { useLocation } from "react-router-dom";
import * as staticConfigs from '../../utilities/staticConfigs'
import i18n from "../../utilities/i18n";
import { headers } from "./menuItems";
import Notifications from "../Notifications/Notifications";

const StyledAppBar = styled(AppBar, {
  shouldForwardProp: (prop) => prop !== 'isExpanded',
})(({ theme, isExpanded }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  boxShadow: 'none',
  zIndex: theme.zIndex.drawer + 1,
  width: `calc(100% - ${isExpanded ? 260 : 70}px)`,
}));



const TopBar = ({ open,isExpanded, onDrawerToggle }) => {

  const pathName = useLocation().pathname;
  const [title, setTitle] = useState('');

  useEffect(() => {
    if (pathName) {
      const setPageTitle = () => {
        if (window.claimInfo && pathName === "/logs/claim") {
          const claimData = window.claimInfo;
          return `${getPageTitle()} Claim# ${claimData.custom_claimId}, ${claimData.patient_Name}`;
        }
        return getPageTitle();
      };

      setTitle(setPageTitle());
    }
  }, [pathName])

  const getPageTitle = () => {
    // 1. Destructure pathname and provide a fallback to prevent crashes 
    // if window or window.location is ever undefined
    const { pathname } = window?.location || { pathname: '' };
  
    // 2. Check for Patient List route
    // Using .includes() is more readable than .indexOf() >= 0
    if (pathname.includes(staticConfigs.ROUTE_PATIENTS_LIST + '/')) {
      return i18n.t('menuNames.patients');
    }
  
    // 3. Extract Claim ID
    // Fixed typo: was "pathnamename", now correctly "pathname"
    const claimMatch = pathname.match(/\/claim-beta\/claim-view\/(\+?\d+)/);
  
    if (claimMatch) {
      const claimId = claimMatch[1];
      const baseTitle = i18n.t('menuNames.claim_beta.view_claim');
      return `${baseTitle} - ${claimId}`;
    }
  
    // 4. Check headers mapping or return default project name
    const menuKey = headers[pathname];
  
    if (menuKey) {
      return i18n.t(menuKey);
    }
  
    return i18n.t('projectName');
  };



  return (
    <StyledAppBar position="fixed" isExpanded={isExpanded}>
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Stack direction="row" spacing={2} alignItems="center">
          <IconButton onClick={onDrawerToggle} color="inherit">
            {open ? <MenuOpenIcon /> : <MenuIcon />}
          </IconButton>
          <Typography variant="h6" fontWeight={500}>
            {title}
          </Typography>
        </Stack>

        <Stack direction="row" spacing={1.5} alignItems="center">
          {/* <ThemeToggleButton /> */}
          <Notifications />
          <ProfileMenu />
        </Stack>
      </Toolbar>
    </StyledAppBar>
  );
};

export default TopBar;